import React, { useState, useEffect, useRef } from 'react';

const QuizQuestionPage = ({ page, lesson, selectedAnswer, answerIsCorrect, onAnswer, onNext, isCheckpointPassed = false, canAttempt = true, triggerFeedback = false }) => {
  
  const [localSelection, setLocalSelection] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const previousPageId = useRef(page.id);
  const userSelectedRef = useRef(false); 
  const feedbackTriggeredRef = useRef(false);

  
  useEffect(() => {
    if (previousPageId.current !== page.id) {
     
      setShowFeedback(false);
      feedbackTriggeredRef.current = false;
      setLocalSelection(null);
      userSelectedRef.current = false;
      previousPageId.current = page.id;
    }
  }, [page.id]); 

 
  useEffect(() => {
    if (selectedAnswer && selectedAnswer !== localSelection) {
      setLocalSelection(selectedAnswer);
    }
  }, [selectedAnswer]);


  useEffect(() => {
    const hasSelection = localSelection || (selectedAnswer !== undefined && selectedAnswer !== null && selectedAnswer !== '');
    if (triggerFeedback && hasSelection && !showFeedback && !feedbackTriggeredRef.current) {
      setShowFeedback(true);
      feedbackTriggeredRef.current = true;
      
    }
   
    if (!triggerFeedback && feedbackTriggeredRef.current) {
     
    }
  }, [triggerFeedback, localSelection, selectedAnswer, showFeedback]);

  const handleOptionClick = (optionId) => {
    if (isCheckpointPassed || !canAttempt || showFeedback) {
      return;
    }
    
    userSelectedRef.current = true;
    setLocalSelection(optionId);
    onAnswer(optionId);
  };

  const getOptionStyle = (option) => {
    const hasSelection = localSelection || (selectedAnswer !== undefined && selectedAnswer !== null && selectedAnswer !== '');
    const selectedId = localSelection || selectedAnswer;
    const selectionMatchesCurrentPage = selectedId && page.options?.some(opt => opt.id === selectedId);
    
    const isAnswerCorrect = answerIsCorrect !== undefined ? answerIsCorrect : null;
    
    if (showFeedback && hasSelection && selectionMatchesCurrentPage) {
      const isSelected = selectedId === option.id;
      
      let isCorrect = false;
      if (isAnswerCorrect !== null) {
        isCorrect = isSelected && isAnswerCorrect;
      }
      
      if (isCorrect) {
        return '!border-green-500 border-2 cursor-default bg-white'; 
      }
      if (isSelected && isAnswerCorrect === false) {
        return 'border-red-500 border-2 bg-red-100 font-semibold cursor-default';
      }
      return 'border-gray-300 border-2 bg-gray-50 cursor-default opacity-60';
    }
    
    if (localSelection === option.id) {
      return 'border-blue-500 border-2 bg-blue-100 font-semibold cursor-pointer'; 
    }
    
    if (isCheckpointPassed || !canAttempt) {
      return 'border-gray-200 border-2 bg-gray-50 text-gray-400 cursor-not-allowed opacity-60';
    }
    
    return 'cursor-pointer hover:bg-gray-50 border-gray-300 border-2';
  };

  return (
    <div>
     
      <div className="mb-4">
        <span className="text-sm text-gray-600">
          Question {page.questionNumber} of {page.totalQuestions}
        </span>
      </div>

      <h2 className="text-xl font-semibold mb-6 text-gray-800">{page.question.text}</h2>

      <div className="space-y-3 mb-6">
        {page.options.map(option => {
          const style = getOptionStyle(option);
          const selectedId = localSelection || selectedAnswer;
          const isSelected = selectedId === option.id;
          const hasSelection = localSelection || (selectedAnswer !== undefined && selectedAnswer !== null && selectedAnswer !== '');
          const selectionMatchesCurrentPage = selectedId && page.options?.some(opt => opt.id === selectedId);
          
          const isAnswerCorrect = answerIsCorrect !== undefined ? answerIsCorrect : null;
          let shouldShowGreen = false;
          
          if (showFeedback && hasSelection && selectionMatchesCurrentPage) {
            if (isAnswerCorrect === true) {
              shouldShowGreen = isSelected;
            }
          }
          
          const inlineStyle = shouldShowGreen
            ? { borderColor: '#10b981', borderWidth: '2px', borderStyle: 'solid' }
            : {};
          
          return (
            <button
              key={option.id}
              onClick={() => handleOptionClick(option.id)}
              disabled={!canAttempt || showFeedback}
              className={`w-full text-left p-4 rounded-lg transition-colors ${style}`}
              style={inlineStyle}
            >
              <span className="font-semibold mr-2">{option.label}.</span>
              {option.text}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuizQuestionPage;

